import { useTranslation } from "react-i18next";
import { useAllPatientData, useDeleteExport } from "../queries/patients-query";
import { ConfirmDeleteDialog } from "./ConfirmDeleteDialog";
import { useAppContext } from "../context/AppContext";
import { useParams } from "react-router";
import { useCallback } from "react";

const DeleteExportDialog = () => {
  const { mutateAsync: deleteExport } = useDeleteExport();
  const { id: patientId } = useParams<{ id: string }>();
  const { data: exports } = useAllPatientData(patientId);

  const {
    deleteExportDialog: { open, id, date },
    setDeleteExportDialog,
    dataConfig,
    setDataConfig,
  } = useAppContext();

  const { t } = useTranslation();

  const onDeleteCancel = () =>
    setDeleteExportDialog({ open: false, id: null, date: null });

  const onDeleteConfirm = useCallback(async () => {
    if (!id) return;
    try {
      await deleteExport(id);
    } catch (error) {
      console.error("Failed to delete export", error);
    } finally {
      setDeleteExportDialog({ open: false, id: null, date: null });
      if (dataConfig.exportId === id && exports) {
        const currentIndex = exports.findIndex(
          (exportItem) => exportItem.exportId === id
        );
        const exportId =
          exports[currentIndex + 1]?.exportId ||
          exports[currentIndex - 1]?.exportId ||
          null;
        setDataConfig((s) => ({ ...s, exportId }));
      }
    }
  }, [id, dataConfig.exportId, exports]);

  return (
    <ConfirmDeleteDialog
      open={open}
      onDiscard={onDeleteCancel}
      onConfirm={onDeleteConfirm}
      dialogTitle={t("patient.delete-export-title")}
      dialogMessage={t("patient.delete-export-text", {
        exportDate: date,
      })}
    />
  );
};

export default DeleteExportDialog;
